import { render, staticRenderFns } from "./dialog-show-close.mpx?vue&type=template&id=4b64e780&isComponent&outputPath=components%2Fdialog-show-close372a21e9%2Findex"
import script from "./dialog-show-close.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-show-close372a21e9%2Findex"
export * from "./dialog-show-close.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-show-close372a21e9%2Findex"
import style0 from "./dialog-show-close.mpx?vue&type=style&index=0&id=4b64e780&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_372a21e9%22%7D&isComponent&outputPath=components%2Fdialog-show-close372a21e9%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports